/* eslint-disable max-len */
const api = {
  policyList: '/v1/mma/connect/clients/{mmaclientid}/policies?category={category}&type={type}&start={start}&count={count}',
  productDetail: '/v1/mma/connect/products/{productCode}/details?region={region}&lang={lang}',
  policyDetail: '/v1/mma/connect/clients/{mmaclientid}/policies/details?type={type}',
  applicationList: '/v1/mma/connect/clients/{mmaclientid}/applications?category={category}&start={start}&count={count}',
  applicationDetail: '/v1/mma/connect/clients/{mmaclientid}/applications/details',
  getApplicationListForProUser: '/v1/mma/connect/users/{uin}/policies?start={start}&count={count}',
  getApplicationDetailForProUser: '/v1/mma/connect/users/{uin}/policies/{policyid}',
  hotlistDetail: '/v1/mma/connect/banners/{bannerId}/details?region={region}',
  newsDetail: '/v1/mma/connect/message/detail/{msgId}',
  yfWebLink: '/v1/mma/connect/weblink',
  submitHistoryList: '/v1/mma/connect/users/{uin}/policies/premium/payment/history?type={category}&start={start}&count={count}',
  submitHistoryDetail: '/v1/mma/connect/users/{uin}/changesvc/{changeid}/details',
  changeSubmitHistoryList: '/v1/mma/connect/clients/{mmaclientid}/changesvcs?type={type}&start={start}&count={count}',
  paymentServiceList: '/v1/mma/connect/clients/{mmaclientid}/policies/payable?type={type}&start={start}&count={count}',
  consultantServiceDetail: '/v1/mma/connect/users/{uin}/agentsvc/{agentsvcid}/details',
  consultantService: '/v1/mma/connect/users/{uin}/agentsvc/{agentsvcid}',
  consultantServiceClient: '/v1/mma/connect/clients/{mmaclientid}/agentsvc/{agentsvcid}',
  consultantServiceCheck: '/v1/mma/connect/clients/{mmaclientid}/agentsvc/mmacheck?category={category}&policyno={policyno}',
  paymentStatus: '/v1/mma/connect/payment/status/{id}',
  paymentNotice: '/v1/mma/connect/users/{uin}/agentsvc/{agentsvcid}/epayment/{epaymentid}',
  paymentMethod: '/v1/mma/connect/clients/{mmaclientid}/policies/{policyno}/payment/method?type={type}',
  terms: '/v1/mma/connect/clients/{mmaclientid}/policies/{policyno}/reinstate/payment?type={type}&detail={detail}',
  flags: '/v1/mma/connect/users/{uin}/currencyinfos',
  fileList: '/v1/mma/connect/clients/{mmaclientid}/docs?start={start}&count={count}&startdate={startdate}&enddate={enddate}&category={category}&key={key}',
  planList: '/v1/mma/connect/clients/{mmaclientid}/plans',
  docsearch: '/v1/mma/connect/clients/{mmaclientid}/files/search?key={key}',
  changesvc: '/v1/mma/connect/clients/{mmaclientid}/policies/{policyno}/changesvc',
  promotion: '/v1/mma/connect/clients/{mmaclientid}/promotionauth/changesvc',
  changeContact: '/v1/mma/connect/clients/{mmaclientid}/policies/changesvc',
  personalinfo: '/v1/mma/connect/clients/{mmaclientid}/personalinfo',
  consultantCardDetail: '/v1/mma/smt/public/agent/{agentcode}/cardinfo?lang={lang}',
  fileDownload: '/v1/mma/oss/public/{oid}',
  getMPFInfo: '/v1/mma/connect/clients/{acctid}/accounts/{mpfaccountid}/personalinfo',
  updateMPFInfo: '/v1/mma/connect/clients/{acctid}/accounts/{mpfaccountid}/changepersonalinfo',
  imageDownload: '/v1/mma/connect/oss/{categoryid}/{oid}',
  getClaimApplicationRecord: '/v1/mma/connect/users/{uin}/eb/{acctid}/eclaimhistory',
  submitRecordListMPF: '/v1/mma/connect/clients/{acctid}/accounts/{mpfaccountid}/changesvcs',
  getMPFFile: '/v1/mma/connect/clients/{acctid}/accounts/{mpfaccountid}/docs?category={category}&start={start}&count={count}&starttime={starttime}&endtime={endtime}',
  getEBFile: '/v1/mma/connect/users/{uin}/eb/{acctid}/docs?start={start}&count={count}&datefrom={datefrom}&dateto={dateto}&order={order}',
  submitRecordDetailMPF: 'v1/mma/connect/clients/{acctid}/accounts/{mpfaccountid}/changesvc/{changeid}',
  submitEBFile: '/v1/mma/connect/users/{uin}/eb/{acctid}/doc/submit',
  submitFileHistory: '/v1/mma/connect/users/{uin}/eb/{acctid}/doc/submithistory?datefrom={datefrom}&dateto={dateto}&order={order}&start={start}&count={count}',
  uploadFiles: '/v1/mma/connect/oss/{categoryid}',
  getCountryCode: '/v1/mma/connect/countrycode',
  getEclaimtncUrl: '/v1/mma/connect/users/{uin}/eb/{acctid}/eclaimtnc',
  survivalPolicyList: '/v1/mma/connect/clients/survival',
  survivalSubmit: '/v1/mma/connect/clients/{mmaclientid}/policies/{policyno}/changesvc',
  survivalSubmitV2: '/v2/mma/connect/clients/{mmaclientid}/policies/{policyno}/changesvc',
  ekycStatus: '/v1/mma/connect/clients/{refno}/ekyc/status',
  ekycCompare: '/v1/mma/connect/clients/{refno}/ekyc/compare',
  ekycResult: '/v1/mma/connect/clients/{refno}/ekyc/result',
  survivalCheckSubmitPolicy: '/v1/mma/connect/clients/{mmaclientid}/policies/submitchecking',
  bocmInfo: '/v1/mma/connect/clients/{mmaclientid}/bocm',
  getBanks: '/v1/mma/connect/clients/banks?bankCodes={bankCodes}',
  getBankName: '/v1/mma/connect/clients/getbankname?bankCode={bankCode}&branchCode={branchCode}',
  mmah5tokenV2: '/v2/mma/connect/clients/{clientid}/mmah5tk',
  getDashboardFunctions: '/v1/mma/connect/users/{uin}/functions?type={type}',
  getProfile: '/v2/mma/connect/users/{uin}/profile',
  getFunctions: '/v1/mma/connect/users/{uin}/functions?type={type}'
}

export default api
